import { FC } from "react";
import { Routes, Route } from "react-router-dom";
import { Container } from "@chakra-ui/react";
import { LoginScreen } from "../../../auth/screens";
import { HomeScreen } from "../../../home/screens";
import { AppLayout } from "./../../../appLayout/screens";
import { Travel } from "../../../travel/screens";
import { Vehicles } from "../../../vehicle/screens";
import { Stock } from "../../../stock/screens";
import { Sending } from "./../../../sending/screens/";
import { EditUser } from "../../../editUser/screens";
import { EditTravel } from "../../../editTravel/screens";
import { VehicleMarkListScreen } from "../../../vehicleMark/screens";
import { VehicleTypeListScreen } from "../../../vehicleType/screens";
import { PromoStatusListScreen } from "../../../promoStatus/screens";
import { AchievmentListScreen } from "../../../achievment/screens";
import { VehicleTariffScreen } from "../../../vehicleTariff/screens";
import { PushScreen } from "../../../push/screens";
import { AddVehicles } from "../../../vehicle/screens/AddVehicles";
import { EditVehicle } from "../../../vehicle/screens/EditVehicle";
import { TravelSet } from "../../../travel/screens/TravelSet";
import "../../../../assets/fonts/Proxima/stylesheet.css";
import { VehiclePopularListScreen } from "../../../vehiclePopular/screens";
import { ColorListScreen } from "../../../color/screens";
import { ArticleListScreen, ArticleSetScreen } from "../../../article/screens";
import {
  PromoblockListScreen,
  PromoblockSetScreen,
} from "../../../promoblock/screens";
import { VehicleStockListScreen } from "../../../vehicleStock/screens";
import { VehicleNewListScreen } from "../../../vehicleNew/screens";
import { ArticleCategoryListScreen } from "../../../articleCategory/screens";

export const Root: FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginScreen />} />
      <Route path="/" element={<AppLayout component={<HomeScreen />} />} />
      <Route
        path="/edit_user/:id"
        element={<AppLayout component={<EditUser />} />}
      />
      <Route path="/travel" element={<AppLayout component={<Travel />} />} />
      <Route
        path="/travel_set/:id"
        element={<AppLayout component={<TravelSet />} />}
      />
      <Route
        path="/travel_set"
        element={<AppLayout component={<TravelSet />} />}
      />
      <Route
        path="/edit_travel/:id"
        element={<AppLayout component={<EditTravel />} />}
      />
      <Route
        path="/vehicles"
        element={<AppLayout component={<Vehicles />} />}
      />
      <Route
        path="/edit_vehicle/:id"
        element={<AppLayout component={<EditVehicle />} />}
      />
      <Route
        path="/vehicle_tariff/:vehicle_id"
        element={<AppLayout component={<VehicleTariffScreen />} />}
      />
      <Route
        path="/add_vehicle"
        element={<AppLayout component={<AddVehicles />} />}
      />
      <Route path="/stock" element={<AppLayout component={<Stock />} />} />
      <Route path="/sending" element={<AppLayout component={<Sending />} />} />
      <Route
        path="/vehicle-mark"
        element={<AppLayout component={<VehicleMarkListScreen />} />}
      />
      <Route
        path="/article-category"
        element={<AppLayout component={<ArticleCategoryListScreen />} />}
      />
      <Route
        path="/vehicle-type"
        element={<AppLayout component={<VehicleTypeListScreen />} />}
      />
      <Route
        path="/promo-status"
        element={<AppLayout component={<PromoStatusListScreen />} />}
      />
      <Route
        path="/achievment"
        element={<AppLayout component={<AchievmentListScreen />} />}
      />
      <Route path="/push" element={<AppLayout component={<PushScreen />} />} />
      <Route
        path="/vehicle-popular"
        element={<AppLayout component={<VehiclePopularListScreen />} />}
      />
      <Route
        path="/vehicle-stock"
        element={<AppLayout component={<VehicleStockListScreen />} />}
      />
      <Route
        path="/vehicle-new"
        element={<AppLayout component={<VehicleNewListScreen />} />}
      />
      <Route
        path="/color"
        element={<AppLayout component={<ColorListScreen />} />}
      />
      <Route
        path="/article"
        element={<AppLayout component={<ArticleListScreen />} />}
      />
      <Route
        path="/article_set/:article_id"
        element={<AppLayout component={<ArticleSetScreen />} />}
      />
      <Route
        path="/article_set"
        element={<AppLayout component={<ArticleSetScreen />} />}
      />
      <Route
        path="/promoblock"
        element={<AppLayout component={<PromoblockListScreen />} />}
      />
      <Route
        path="/promoblock_set/:promoblock_id"
        element={<AppLayout component={<PromoblockSetScreen />} />}
      />
      <Route
        path="/promoblock_set"
        element={<AppLayout component={<PromoblockSetScreen />} />}
      />
    </Routes>
  );
};
